import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import dayjs from "dayjs"
import { ICase, ICaseFields } from "./case.type"
import { Case } from "./case"
import { GetCasesByCoreIdQuery } from "@/api/hasura/generated/graphql"
import { safeDayjs } from "@/helpers/dateHelper"

interface ICaseFieldsRaw {
  title: string
  status: string
  due_date: string
  case_reason: string
  customer_id: string
  assigned_user: string
  assigned_queue: string
  reference_number: string
  assigned_agent_name: string
  last_updated_datetime: string
  first_assigned_agent_name: string
  first_assigned_queue_name: string
  [key: string]: string | number | null
}

const FieldsParser: IParser<Partial<ICaseFields>, ICaseFieldsRaw> = {
  toDomain(data: ICaseFieldsRaw): Partial<ICaseFields> {
    try {
      return {
        referenceNumber: data.reference_number,
        customerId: data.customer_id,
        title: data.title,
        status: data.status,
        caseReason: data.case_reason,
        assignedQueue: data.assigned_queue,
        assignedQueueName: data.first_assigned_queue_name,
        assignedUser: data.assigned_user,
        assignedAgentName: data.assigned_agent_name,
        firstAssignedQueueName: data.first_assigned_queue_name,
        firstAssignedAgentName: data.first_assigned_agent_name,
        dueDate: safeDayjs(data.due_date),
        lastUpdatedDate: safeDayjs(data.last_updated_datetime),
      }
    } catch (error) {
      throw new ParseError(error)
    }
  },
}

export type ICaseRaw = GetCasesByCoreIdQuery["cases"][0]

export const CaseParser: IParser<ICase, ICaseRaw> = {
  toDomain(data: ICaseRaw): ICase {
    try {
      return new Case(
        data.id,
        data.external_id,
        FieldsParser.toDomain(data.fields),
        dayjs(data.created_at),
        dayjs(data.updated_at),
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
